/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 *
 * @param num :  the number to be formatted
 * @param shouldAddPlusSign : whether or not to add a plus sign to indicate that a larger number
 * of files than what is shown actually exists.
 * @returns the formatted number in units of thousands.
 */
export const formatNumberOfDocuments = (num: number, shouldAddPlusSign: boolean) => {
    if (num > 999) {
        const stringRepresentation = num.toString();

        return `${stringRepresentation.slice(0, -3)}${
            stringRepresentation.slice(-3, -2) !== '0' ? `.${stringRepresentation.slice(-3, -2)}k` : 'k'
        }${shouldAddPlusSign ? '+' : ''}`;
    }

    return num;
};
